
export function isFormatCompatible(type: string, format: string) {
    if (format === 'EURO') {
        if (type !== 'INT' && type !== 'DOUBLE' && type !== 'FLOAT' && type !== 'FORMULA') {
            return false;
        }
    } else
    if (format === 'DEZIMAL(2)') {
        if (type !== 'DOUBLE' && type !== 'FLOAT' && type !== 'FORMULA') {
            return false;
        }
    }
    return true;
}
export function isAggregationCompatible(type: string, aggregation: string) {
    if (aggregation === 'SUM') {
        if (type !== 'INT' && type !== 'DOUBLE' && type !== 'FLOAT') {
            return false;
        }
    }
    return true;
}
export function isSummaryCompatible(type: string, summary: string) {
    if (summary === 'SUM') {
        if (type !== 'INT' && type !== 'DOUBLE' && type !== 'FLOAT') {
            return false;
        }
    }
    return true;
}
